import ContentContainer from "layout/Content/ContentContainer";
import Trans from "features/translation/components/Trans";
import LoginForm from "features/authentication/components/LoginForm/LoginForm";
import { Redirect } from "react-router-dom";
import { useAccount } from "context/AccountContext";

const Login = () => {
  const { user } = useAccount();

  if (user) {
    return <Redirect to="/startpagina"/>;
  }

  return (
    <ContentContainer contentBackground={ true }
                      contentPadding={ true }
                      contentGridType={ 'small' }
                      containerPadding={ true }>
      <h1><Trans text="Inloggen"/></h1>
      <LoginForm/>
    </ContentContainer>
  )
}

export default Login;
